module.exports = __webpack_public_path__ + "static/img/084_TO8_1734.eb8f076.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/084_TO8_1734.jpg
// module id = NxC6
// module chunks = 0